import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { motion } from 'framer-motion';

export const BackButton = ({ to, label = 'Back' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <motion.button
      onClick={handleClick}
      className="fixed top-8 left-8 z-50 flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#1A1A1A] opacity-70 hover:opacity-100 transition-opacity duration-300 bg-transparent border-none cursor-pointer"
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 0.7, x: 0 }}
      transition={{ duration: 0.5, delay: 0.3 }}
      whileHover={{ opacity: 1 }}
      data-testid="back-button"
    >
      <ChevronLeft size={16} />
      {label}
    </motion.button>
  );
};

export default BackButton;
